import { ethers as e } from "ethers";
import { TestTokenPoolContractAbi as r } from "@deorderbook/contracts/abi";
import { TestTokenPoolAddress as n } from "@deorderbook/contracts";
import { signer as s, provider as c } from "./provider.mjs";
const i = () => new e.Contract(
  n,
  r
), f = (t = !1) => {
  const o = i();
  return t ? o.connect(s) : o.connect(c);
};
export {
  i as initTestTokenPoolContract,
  f as useTestTokenPoolContract
};
//# sourceMappingURL=testTokenPoolContract.mjs.map
